module.exports = __webpack_public_path__ + "static/media/coconut_orange.fdf30298.jpg";